import { Outlet } from "react-router-dom";

const PersonaPrueba = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default PersonaPrueba;
